import groupBy from 'lodash/groupBy';
import React from 'react';

import AlternateCampingIcon from '@/components/icons/AlternateCamping.svg';
import ClockIcon from '@/components/icons/Clock.svg';
import ReservationIcon from '@/components/icons/Reservation.svg';
import { ILocation } from '@/services/getCMSPageData';

import css from './Campsites.module.css';

interface ICampground {
  description: string;
  location: ILocation;
  scheduling: string;
  title: string;
}

interface IProps {
  campgrounds: ICampground[];
  title: string;
}

const categories = [
  {
    name: 'reservations',
    label: 'Reservations camping',
    icon: ReservationIcon,
  },
  {
    name: 'first_come_first_served',
    label: 'First-come first-served',
    icon: ClockIcon,
  },
  { name: 'alternate', label: 'Alternate camping', icon: AlternateCampingIcon },
];
const renderCampsites = (campSites: ICampground[] | undefined) => {
  return (
    <>
      {campSites?.map(campsite => {
        return (
          <div key={campsite.title}>
            <h4>{campsite.title}</h4>
            <div
              className={css.paragraph}
              dangerouslySetInnerHTML={{ __html: campsite.description }}
            />
          </div>
        );
      })}
    </>
  );
};
const Campsites: React.FC<IProps> = ({ campgrounds, title }) => {
  const content = groupBy(campgrounds, 'scheduling');
  return (
    <>
      <h2 className="mb-4 highlight autoType800">Campsites in {title}</h2>
      {categories.map(category => {
        const Icon = category.icon;
        if (!content[category.name]) {
          return null;
        }

        return (
          <div key={category.name} className={css.section}>
            <h3>
              <Icon className={css.icon} />
              {category.label}
            </h3>
            {renderCampsites(content[category.name])}
          </div>
        );
      })}
    </>
  );
};

export default Campsites;
